import { Injectable } from "@angular/core";
import * as crypto from "crypto-js";
import { webSocket, WebSocketSubject } from "rxjs/webSocket";
import { environment } from "src/environments/environment";
import * as uuid from "uuid";

@Injectable({
	providedIn: "root",
})
export class VenueSocketService {
	socket: WebSocketSubject<any> = webSocket(environment.production ? "wss://ws.focuslink.focuspos.com/" : "wss://dev.ws.focuslink.focuspos.com/");
	connectionVenueKey: number;
	licenseKey = environment.licenseKey;
	licenseSecret = "06fa2be0-7470-4080-a146-4b73d1052866";

	constructor() {}

	async connect(venueKey: number) {
		const registrationMessage = {
			action: "registerDevice",
			key: this.licenseKey,
			signature: this.flGenerateSignature(this.licenseKey, this.licenseSecret),
			type: "venueMessage",
			venueKey: venueKey,
			request: {
				requestContext: {
					domainName: environment.production ? `app.focuspos.com` : `dev.onlineorder.focuspos.com`,
				},
				path: "/v2/licenses/verify",
			},
		};

		const res = await this.socket.next(registrationMessage);
		this.connectionVenueKey = venueKey;
	}

	async awaitMessage() {
		this.socket.subscribe((message) => {
			//do something with message
		});
	}

	async disconnect(venueKey: number, newVenueKey?: number) {
		this.connectionVenueKey = 0;

		const res = await this.socket.next({
			action: "deregisterDevice",
			key: this.licenseKey,
			venueKey: venueKey,
		});
	}

	flGenerateSignature(apiKey: string, apiSecret: string) {
		const domain = environment.production ? `app.focuspos.com` : `dev.onlineorder.focuspos.com`;

		const prefix = "hmac";
		const timestamp = new Date().getTime(); // UTC time in milliseconds since the Unix epoch
		const nonce = uuid.v4();

		const url = `${domain}/v2/licenses/verify`;

		const sigRawData = `${this.licenseKey}:POST:${url}:${timestamp}:${nonce}`;
		return `${this.generateHash(sigRawData, this.licenseSecret)}:POST:${url}:${timestamp}:${nonce}`;
	}

	generateHash(message: string, secret: string): string {
		const hash = crypto.HmacSHA256(message, secret);
		const b64Hash = crypto.enc.Base64.stringify(hash);
		return b64Hash;
	}
}
